export default function Section19() {
    return (
        <div className="w-full py-[60px] md:py-[60px] bg-[#f9f9f9] text-center SectionCTA">
            {/* Heading */}
            <h2 className="text-[28px] md:text-[30px] font-bold text-[#151515] leading-[32px] md:leading-[41px] mb-4">
                Let’s Build an Amazing Website for your Business Together
            </h2>

            {/* Subheading */}
            <p className="text-[#555] text-[16px] md:text-[18px] mb-8 max-w-[650px] mx-auto">
                Stop settling for a mediocre online presence. Let's partner to create a powerful website that achieves your business goals.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center px-4">
                <a
                    href="https://mean3.com/contact-mean3"
                    className="bg-[#DA2128] hover:bg-[#b71c22] text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300 inline-block text-center"
                >
                    Get a Free Proposal
                </a>
                <a
                    href="https://mean3.com/contact-mean3"
                    className="border border-[#DA2128] text-[#DA2128] hover:bg-[#DA2128] hover:text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300 inline-block text-center"
                >
                    Book a Free Strategy Call
                </a>
            </div>




        </div>
    );
}
